
import generateVersionHash from '@utils/generateVersionHash';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';

const cmer = {
  namespaced: true,
  state: createListState(),
  mutations: createListMutations(),
  actions: {
    async getData(
      ctx,
      { date, page, itemsPerPage, search,  }
    ) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sortBy = 'id DESC';

      const cleanedSearch = {
        code: search.code || '',
        definition: search.definition || '',
        created_at: Array.isArray(search.created_at) && search.created_at.length === 2 
          ? `${search.created_at[0]} to ${search.created_at[1]}`
          : (search.created_at || ''),
        updated_at: Array.isArray(search.updated_at) && search.updated_at.length === 2
          ? `${search.updated_at[0]} to ${search.updated_at[1]}`
          : (search.updated_at || ''),
      };

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search: cleanedSearch,
        sort_by: sortBy,
        version: generateVersionHash(
          itemsPerPage.toString() + page.toString(),
          date
        ),
      });

      const urlApi = api.GET_LIST_MASTER_CMER;

      try {
        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code === 200) {
          ctx.commit('setTotalData', {
            payload: responseData,
          });
          ctx.commit('setData', { payload: responseData });
        }
      } catch (error) {
        console.error('Error fetching CMER data:', error);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async createData(ctx, { date, code, definition }) {
      const data = JSON.stringify({
        code,
        definition,
        version: generateVersionHash(code + definition, date),
      });

      const urlApi = api.CREATE_MASTER_CMER;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },

    async updateData(ctx, { date, id, code, definition }) {
      const data = JSON.stringify({
        id: id.toString(),
        code,
        definition,
        version: generateVersionHash(id.toString() + code + definition, date),
      });

      const urlApi = api.UPDATE_MASTER_CMER;
      const responseData = await postApi(ctx, urlApi, data);

      return responseData;
    },
  },
};

export default cmer;
